
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    videoPosts: {
      type: Array,
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 4,
    },
    background: {
      type: String,
      default: ``,
    },
  },
  data () {
    return {
      videos: [],
      activeElement: null,
      modalOpen: false,
      carouselOptions: {
        slidesPerView: 1,
        spaceBetween: 32,
        slidesPerGroup: 1,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1232: {
            slidesPerView: this.perPage,
            slidesPerGroup: this.perPage,
          },
        },
      },
      carousel: null,
    };
  },
  computed: {
    numVideos () {
      return this.videos.length;
    },
    sliderName () {
      if (this.block.title) {
        return `carousel-${this.slugify(this.block.title)}`;
      }
      return `carousel-${Math.floor(Math.random() * 1000)}`;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getVideos();
    });
  },
  methods: {
    nextSlide () {
      this.carousel.slideNext(500);
    },
    prevSlide () {
      this.carousel.slidePrev(500);
    },
    async getVideos () {
      const queryParams = {
        fields: `id,title,excerpt,acf,image,slug,type`,
        posts: {
          post_type: `video`,
          posts_per_page: this.videos.length,
          post__in: this.videoPosts.map(video => video.ID),
          orderby: `post__in`,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.videos = request;
      }
    },
  },
};
